import { call, put, spawn } from 'typed-redux-saga/macro';

import { isEnabled } from 'Config';
import { debugApp as debug } from 'Lib/debug';
import tabWatcher from 'Lib/tabWatcher';

import { deactivateTab } from '../actions';

export function* tabWatcherSaga() {
  // We don't want the inactive tab screen to show in Tinder Lite
  if (!isEnabled('tabWatch')) return;

  try {
    tabWatcher.register();
  } catch (e) {
    return;
  }

  yield* call(tabWatcher.activeTabChange);
  yield* put(deactivateTab());

  debug('inactive tab');
}

export function* handleTabWatch() {
  yield* spawn(tabWatcherSaga);
}
